import { useSyncExternalStore } from "react";
import { isSocketConnected, onSocketConnectionChange } from "../../chatSocket";

// Live WS connection state for anything that wants to show a connection-
// quality indicator (currently Watch Together's status bar) - same
// useSyncExternalStore pattern as useLockState.ts.
export function useSocketConnected(): boolean {
  return useSyncExternalStore(onSocketConnectionChange, isSocketConnected);
}
